/**
 * =============================================================================
 * HASTA DONDE LLEGA UN MOVIL
 * =============================================================================
 * Numero de items a partir del cual administrar una escala desde el telefono
 * deja de ser comodo y empieza a ser una mala idea.
 *
 * El corte en 20 no es arbitrario: por debajo estan las escalas que un
 * terapeuta pasa de pie, con el paciente delante (GDS-15, NPT-ES, STAI, Lawton).
 * Por encima esta Ryff, con 39 items, que son unos diez minutos de trabajo
 * seguido y que nadie hace con el pulgar si tiene un ordenador cerca.
 *
 * No es un bloqueo: es decirlo ANTES del item 1, en vez de que se descubra a
 * mitad de camino.
 * =============================================================================
 */
export const MAX_ITEMS_MOVIL = 20;
